import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"];
import BasePopper from '@mui/base/Popper';
import { useThemeWithoutDefault as useTheme } from '@mui/system';
import { HTMLElementType, refType } from '@mui/utils';
import * as React from 'react';
import { styled, useThemeProps } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
var PopperRoot = styled(BasePopper, {
  name: 'MuiPopper',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({});

/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */
var Popper = /*#__PURE__*/React.forwardRef(function Popper(inProps, ref) {
  var _slots$root;
  var theme = useTheme();
  var props = useThemeProps({
    props: inProps,
    name: 'MuiPopper'
  });
  var anchorEl = props.anchorEl,
    component = props.component,
    components = props.components,
    componentsProps = props.componentsProps,
    container = props.container,
    disablePortal = props.disablePortal,
    keepMounted = props.keepMounted,
    modifiers = props.modifiers,
    open = props.open,
    placement = props.placement,
    popperOptions = props.popperOptions,
    popperRef = props.popperRef,
    transition = props.transition,
    slots = props.slots,
    slotProps = props.slotProps,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
  var otherProps = _extends({
    anchorEl: anchorEl,
    container: container,
    disablePortal: disablePortal,
    keepMounted: keepMounted,
    modifiers: modifiers,
    open: open,
    placement: placement,
    popperOptions: popperOptions,
    popperRef: popperRef,
    transition: transition
  }, other);
  return /*#__PURE__*/_jsx(PopperRoot, _extends({
    as: component,
    direction: theme == null ? void 0 : theme.direction,
    slots: {
      root: RootComponent
    },
    slotProps: slotProps != null ? slotProps : componentsProps
  }, otherProps, {
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Popper;